import {IconEnglish, IconFrench, IconSpanish} from '../../buttons/IconButtons';


export const MODEL_LANGUAGE = {
    ES: {
        transMd: 'ES',
        trans: 'spanish',
        code: 'sp',
        Icon: IconSpanish,
    },
    EN: {
        transMd: 'EN',
        trans: 'english',
        code: 'en',
        Icon: IconEnglish,
    },
    ER: {
        transMd: 'FR',
        trans: 'french',
        code: 'fr',
        Icon: IconFrench,
    }
}
